import { useMemo } from "react";
import { useT } from "../i18n";
import { initials } from "../lib/fleet";
import { buildMenu, withBadge } from "../nav/menu";
import { useSession } from "../state/session";
import { Icon } from "./Icon";
import { TenantSwitcher } from "./TenantSwitcher";
import { TreeMenu, navStorageKey } from "./TreeMenu";

export function Rail({ activeHref, alarmCount = 0, onNavigate }: { activeHref: string; alarmCount?: number; onNavigate: (href: string) => void }) {
  const t = useT();
  const { user, role, data, signOut, platformAdmin } = useSession();
  const menu = useMemo(
    () => (role ? withBadge(buildMenu(data?.siteTree ?? [], role, platformAdmin), "alarms", alarmCount) : []),
    [role, data, platformAdmin, alarmCount],
  );

  return (
    <div className="rail-inner">
      <div className="rail-brand">
        <a href="#/" className="rail-logo-link" onClick={() => onNavigate("#/")}>
          <img src="/brand/expartise-logo-on-dark.png" alt={t("app.logoAlt")} width={150} height={48} className="rail-logo" />
        </a>
        <div className="rail-product">{t("app.productLabel")}</div>
      </div>

      <TenantSwitcher />

      <nav className="rail-nav" aria-label={t("nav.ariaLabel")}>
        <TreeMenu nodes={menu} activeHref={activeHref} onNavigate={onNavigate} storageKey={user ? navStorageKey(user.id) : undefined} />
      </nav>

      {user && (
        <div className="rail-user" aria-label={t("user.menuLabel")} role="group">
          <span className="avatar avatar-rail" aria-hidden="true">
            {initials(user.displayName)}
          </span>
          <span className="rail-user-text">
            <span className="rail-user-name">{user.displayName}</span>
            <span className="rail-user-email">{user.email}</span>
          </span>
          <button type="button" className="icon-button rail-signout" onClick={() => void signOut()} title={t("user.signOut")}>
            <Icon name="logout" size={18} label={t("user.signOut")} />
          </button>
        </div>
      )}
    </div>
  );
}
